import Axios from '@/utils/http'
// 查看个人信息
export function detailUserInfo(data) {
    return Axios.post(window.Glod["ex-account-svc"] + '/user/detailUserInfo', data)
}
// 社区查询工单
export function pageIdea(data) {
    return Axios.post(window.Glod["ex-online-svc"] + '/idea/pageIdea', data)
}